import { composeClasses } from '@/utils/compose-classes'
import { TypeSettings } from './constants'
import { IAlertProps } from './types'
import { Button } from '../buttons'

export const Alert = ({
  type,
  title,
  description,
  padding = 'p-6',
  className,
  containerTextClassName,
  containerIconClassName,
  useIcon = true,
  customIcon,
  isOutlined = false,
  buttonOptions = null
}: IAlertProps) => {
  return (
    <div
      className={composeClasses(
        className,
        TypeSettings[type].backgroundColor,
        padding,
        'rounded-xl '
      )}
    >
      <div className={composeClasses(containerIconClassName, 'flex gap-6')}>
        {useIcon && (
          <span
            id={composeClasses(!isOutlined && 'material-symbols-filled')}
            className={composeClasses(
              'material-symbols-outlined',
              TypeSettings[type].color
            )}
          >
            {customIcon ?? TypeSettings[type].icon}
          </span>
        )}

        <div
          className={composeClasses(
            containerTextClassName,
            'flex flex-col gap-2'
          )}
        >
          <p className="text-body-l text-primary">{title}</p>
          {description && (
            <p className="text-secondary text-body-m">{description}</p>
          )}
          {buttonOptions && (
            <Button
              variant={buttonOptions.variant ?? 'secondary'}
              size={buttonOptions.size ?? 'small'}
              className={buttonOptions.className}
              onClick={buttonOptions.onClick}
            >
              {buttonOptions.label}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default Alert
